import { useState, useCallback } from "react";
import { getAxios } from "../utils/axios";
const endpoint = "/inventory/categories";
export const useInventoryCategories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchAll = useCallback(async (filter) => {
        setLoading(true);
        setError(null);
        try {
            const params = new URLSearchParams();
            if (filter) {
                params.set("filter", JSON.stringify(filter));
            }
            params.set("offset", "0");
            params.set("limit", "100");
            const res = await getAxios().get(`${endpoint}?${params.toString()}`);
            setCategories(res.data);
        }
        catch (err) {
            setError(err.message || "Failed to fetch categories.");
        }
        finally {
            setLoading(false);
        }
    }, []);
    const create = async (payload) => {
        const res = await getAxios().post(endpoint, payload);
        await fetchAll(); // Optional: you could scope by payload.item_id if relevant
        return res.data;
    };
    const update = async (uuid, payload) => {
        const res = await getAxios().put(`${endpoint}/${uuid}`, payload);
        await fetchAll();
        return res.data;
    };
    const patch = async (uuid, payload) => {
        const res = await getAxios().patch(`${endpoint}/${uuid}`, payload);
        await fetchAll();
        return res.data;
    };
    const remove = async (uuid) => {
        const res = await getAxios().delete(`${endpoint}/${uuid}`);
        await fetchAll();
        return res.data;
    };
    return {
        categories,
        loading,
        error,
        fetchAll,
        create,
        update,
        patch,
        remove,
    };
};
